import { Component, OnInit ,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'page-loader',
  templateUrl: './page-loader.component.html',
  styleUrls: ['./page-loader.component.css']
})
export class PageLoaderComponent implements OnInit {

  @Input() showLoader = false;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

  
}
